import { gql } from '@apollo/client';

export const GET_INSTITUTION_NAME = gql`
  query getInstitutionName($input: FilterInstitutions!) {
    institution: getInstitutionName(input: $input) {
      id
      name
    }
  }
`;
